import { apiClient } from './apiClient';

/**
 * Interface for the /auth/whoami response
 */
export interface WhoAmIResponse {
  authenticated: boolean;
  auth_method: string | null;
  auth_required: boolean;
  auth_type: string;
  user: {
    uuid: string;
    email: string;
    name: string;
    type: string;
    auth_provider_user_id: string;
  } | null;
  timestamp: string;
}

/**
 * Service for authentication-related API endpoints
 * Used for testing and verifying authentication state
 */
class AuthService {
  /**
   * Test authentication state using the /auth/whoami endpoint
   * @returns Authentication status and user information
   */
  public async whoAmI(): Promise<WhoAmIResponse> {
    try {
      const response: WhoAmIResponse = await apiClient.get('/auth/whoami');
      console.log('Auth whoami response:', response);
      return response;
    } catch (error) {
      console.error('Error checking authentication state:', error);
      throw error;
    }
  }
}

// Create and export singleton instance
export const authService = new AuthService();